<div
  [hidden]="!isLoadedAndFiltered"
  class="subscription-list-container row g-2 text-start"
>
  <div
    class="col-12 col-sm-6 col-lg-4 cursor-pointer"
    *ngFor="let subscriptionId of filteredSubscriptionIds; let i = index"
    [hidden]="getPrice((subscriptionEntities$ | async)[subscriptionId]) >= 9999"
    [hidden]="!showAllSubscription && i > 2"
    (click)="onSubscriptionClicked(subscriptionId)"
    (keyup.enter)="onSubscriptionClicked(subscriptionId)"
    role="link"
    tabindex="0"
  >
    <div class="position-relative card-ticket rounded">
      <div
        class="d-flex align-items-start align-items-center rounded border p-2"
      >
        <span
          class="avatar me-2 avatar-sm d-flex align-items-center"
          [ngClass]="{
            'bg-primary': isSubscriptionAvailable(
              (subscriptionEntities$ | async)[subscriptionId]
            ),
            'bg-gray': !isSubscriptionAvailable(
              (subscriptionEntities$ | async)[subscriptionId]
            ),
            'bg-gray ': !isSubscriptionAvailable(
              (subscriptionEntities$ | async)[subscriptionId]
            )
          }"
        >
          <i
            class="fa fa-ticket-alt text-white fa-rotate-45"
            aria-hidden="true"
            role="img"
          ></i>
        </span>

        <div class="h5 mb-0 flex-grow-1">
          {{
            (
              subscriptionId
              | getTranslation : 'subscription' : 'description'
              | async
            )?.trim()?.length > 0
              ? (subscriptionId
                | getTranslation : 'subscription' : 'description'
                | async)
              : (subscriptionEntities$ | async)[subscriptionId].description
          }}
        </div>
      </div>
    </div>
  </div>
  <div class="text-center col-12">
    <button
      *ngIf="filteredSubscriptionIds?.length > 3"
      class="btn btn-ghost-primary"
      type="button"
      (click)="showAllSubscription = !showAllSubscription"
      aria-controls="showSubs"
    >
      <i
        *ngIf="showAllSubscription"
        class="fa fa-chevron-left me-2"
        aria-hidden="true"
        role="img"
      ></i>
      {{
        showAllSubscription
          ? ('general.showLess' | translate)
          : ('general.showAll' | translate)
      }}
      <i
        *ngIf="!showAllSubscription"
        class="fa fa-chevron-right ms-2"
        aria-hidden="true"
        role="img"
      ></i>
    </button>
  </div>
  <div *ngIf="filteredSubscriptionIds?.length == 0"
    ><span class="text-muted">{{
      'saleModule.notAvailable' | translate
    }}</span></div
  >
</div>
